/**
 * CategoryFilters Factory
 */
(function () {

    'use strict';

    angular.module('itxApp.catalog')
        .service('ItxFiltersManagerSvc', ItxFiltersManagerSvc);

    ItxFiltersManagerSvc.$inject = [
        'imCategoryFilter',
        'ItxSizeGuideSvc',
        '$q'
    ];

    /**
     * Bridge between category products and selected filters
     * @constructor
     * @name ItxFiltersManagerSvc
     * @type ItxFiltersManagerSvc
     */
    function ItxFiltersManagerSvc(imCategoryFilter, ItxSizeGuideSvc, $q) {

        var _this = this;

        _this.ItxSizeGuideSvc = ItxSizeGuideSvc;
        _this.categoryObject = null;
        _this.filteredProducts = [];
        _this.pagedProducts = [];
        _this.priceRanges = [];
        _this.filterCount = 0;
        _this.orderCount = 0;
        _this.filters = {};
        _this.infiniteScroll = {};
        _this.imCategoryFilter = imCategoryFilter;
        _this.hasCategoryPathFilter = false;
        _this.categoryPathSizes = [];
        _this.subFamilyArr = [];

        /**
         * Initialize filters with the current selection store in  LocalStorage
         */
        ItxFiltersManagerSvc.prototype.initialize = function (categoryObject) {
            
            var _this = this;
            var deferred = $q.defer();
            _this.categoryObject = categoryObject;
            _this.filteredProducts = categoryObject.visibleProducts;
            //ECOMDUTI-4761
            inditex.setCategoryFilter(inditex.iCategoryId, [{}, []], []);
            _this.category = categoryObject;
            _this.infiniteScroll = {start: 0, end: 0};
            _this.pagedProducts = [];
            joyr.catalog.utils.getCategoryOrderAndFilter(inditex.iCategoryId)
            .done(function (filters) {
                _this.filters.types           = _.filter(filters[0].attributes, function (attr) { return attr.type === 'XTYPEFILTER'; });
                _this.filters.qualities       = _.filter(filters[0].attributes, function (attr) { return attr.type === 'XCALFILTER'; });
                _this.filters.characteristics = _.filter(filters[0].attributes, function (attr) { return attr.type === 'XCATFILTER'; });
                _this.filters.colors = filters[0].colors;
                _this.filters.sizes  = filters[0].sizes;
                _this.filters.prices = filters[0].prices;

                if (filters[1] && filters[1].order) {
                    if (filters[1].order === joyr.constants.order.MORE_RELEVANT_ORDERING) {
                        _this.filters.order = 'relevance';
                    } else if (filters[1].order === joyr.constants.order.NEWER_ORDERING) {
                        _this.filters.order = 'newer';
                    } else if (filters[1].order === joyr.constants.order.PRICE_ORDERING &&
                        filters[1].reverse) {
                        _this.filters.order = 'priceDescending';
                    } else if (filters[1].order === joyr.constants.order.PRICE_ORDERING &&
                        !filters[1].reverse) {
                        _this.filters.order = 'priceAscending';
                    }
                }
                _this.applyFilters(
                    _this.filters.types,
                    _this.filters.qualities,
                    _this.filters.characteristics,
                    _this.filters.colors,
                    _this.filters.sizes,
                    _this.filters.prices,
                    _this.filters.order)
                    .then(function(filteredProducts){
                        deferred.resolve(filteredProducts);
                    });
            });

            return deferred.promise;
        };

        ItxFiltersManagerSvc.prototype.initializeCategoryPathFilter = function (configSizes) {
            if (configSizes) {
                _this.hasCategoryPathFilter = true;
                _.forEach(configSizes, function (property) {
                    var size = property.split(':')[1];
                    _this.categoryPathSizes.push(size);
                    var subFamily = property.split(':')[0].replace('S', '');
                    _this.subFamilyArr.push(subFamily);
                });
            }
        };

        ItxFiltersManagerSvc.prototype.getCategoryPathFilter = function () {
            return _this.categoryPathSizes;
        };

        ItxFiltersManagerSvc.prototype.filterProductsBySubfamily = function () {
            var productsFiltered = [];
            _.forEach(_this.subFamilyArr, function (subFamily) {
                subFamily = subFamily.replace(' ', '');
                var subFamilyArrProduts = [];
                _.forEach(_this.filteredProducts, function (product) {
                    var subFamilyId = null;
                    subFamilyId = product.activeDetail.subfamilyInfo.subFamilyCode.toString();
                    if (subFamilyId !== null && subFamilyId === subFamily) {
                        subFamilyArrProduts.push(product);
                    }
                });
                productsFiltered = productsFiltered.concat(subFamilyArrProduts);
            });

            _this.filteredProducts = _.uniqBy(productsFiltered, 'id');
        };

        ItxFiltersManagerSvc.prototype.removeVisibleFiltersByCategoryPath = function (sizes) {
            sizes = sizes.filter(function (e) {
                var result = true;
                _this.categoryPathSizes.forEach(function (x) {
                    if(e.value !== undefined) {
                        if (e.value === x) {
                            result = false;
                        }
                    } else {
                        if (e === x) {
                            result = false;
                        }
                    }
                });
                return result;
            });
            return sizes;
        };

        /**
         * Apply selection
         */
        ItxFiltersManagerSvc.prototype.applyFilters = function (types, qualities, characteristics, colors, sizes, prices, order) {
            var _this = this, filters = [{},{}], deferred = $q.defer();
                
            //Store filters
            _this.filters.types =  types;
            _this.filters.qualities = qualities;
            _this.filters.characteristics =  characteristics;
            _this.filters.colors = colors;
            _this.filters.sizes =  sizes;
            _this.filters.prices =  prices;

            // Adding category sizes filters.
            if (_this.hasCategoryPathFilter) {
                if (_this.filters.sizes !== undefined) {
                    _this.filters.sizes = _.union(_this.filters.sizes, _this.categoryPathSizes);
                } else {
                    _this.filters.sizes = _this.categoryPathSizes;
                }
            }

            //Reset paging
            _this.infiniteScroll = {start: 0, end: 0};
            _this.pagedProducts = [];

            // Reset filters
            _this.filteredProducts = _this.categoryObject.visibleProducts;
            _this.filterCount = 0;
            _this.orderCount = 0;

            //filters = angular.copy([_this.filters]); pasamos siempre el filters [{},{}] ??

            //Set current filters and calculate filter count
            _.each(types, function (attr) {
                joyr.catalog.utils.setAttributeFilter(attr, filters);
            });

            _this.filterCount += types ? types.length : 0;

            _.each(qualities, function (attr) {
                joyr.catalog.utils.setAttributeFilter(attr, filters);
            });

            _this.filterCount += qualities ? qualities.length : 0;

            _.each(characteristics, function (attr) {
                joyr.catalog.utils.setAttributeFilter(attr, filters);
            });

            _this.filterCount += characteristics ? characteristics.length : 0;

            _.each(colors, function (color) {
                joyr.catalog.utils.setColorFilter(color, filters);
            });

            _this.filterCount += colors ? colors.length : 0;
            _.each(sizes, function (size) {
                joyr.catalog.utils.setSizeFilter(size, filters);
            });

            _this.filterCount += _this.filters.sizes ? _this.filters.sizes.length : 0;
            if (_this.hasCategoryPathFilter) {
                _this.filterCount -= _this.categoryPathSizes.length;
            }

            if (prices) {
                if ((prices.minStep !== undefined && (prices.min !== prices.minStep)) ||
                    (prices.maxStep !== undefined && (prices.max !== prices.maxStep))) {

                    joyr.catalog.utils.setPriceFilter({
                        min: prices.min,
                        max: prices.max
                    }, filters);

                    // No se utiliza visualmente. Se comenta por filtrado de categoría.
                    // _this.filterCount += 1;
                }
            }        
            
            //Store filters in browser storage
            joyr.catalog.utils.setCategoryFilter(_this.category.id, filters)
                .done(function () {
                    new joyr.catalog.Filter(_this.filteredProducts, _this.category.id)
                        .done(function (products) {
                            if (order) {
                                _this.orderCount = 1;
                                if (order === 'relevance') {
                                    joyr.catalog.utils.setOrder(joyr.constants.order.MORE_RELEVANT_ORDERING, false, filters);
                                } else if (order === 'newer') {
                                    joyr.catalog.utils.setOrder(joyr.constants.order.NEWER_ORDERING, false, filters);
                                } else if (order === 'priceDescending') {
                                    joyr.catalog.utils.setOrder(joyr.constants.order.PRICE_ORDERING, true, filters);
                                } else if (order === 'priceAscending') {
                                    joyr.catalog.utils.setOrder(joyr.constants.order.PRICE_ORDERING, false, filters);
                                }
                                
                                joyr.catalog.utils.setCategoryOrder(_this.category.id, filters)
                                    .done(function () {

                                        if(_this.filters.sizes){
                                            if(_this.filters.sizes.length > 0){
                                                products.productsFiltered = _this.ItxSizeGuideSvc.productHasSizes( _this.filters.sizes, products.productsFiltered );
                                            }
                                        }
                                        
                                        new joyr.catalog.Order(products.productsFiltered, _this.category.id)
                                            .done(function (products) {                                             
                                                
                                                //products.productsFiltered = products.productsOrdered;
                                                //FILTRAJE por caregoryPageVisibility
                                                _this.filteredProducts = _.filter(products.productsOrdered, function(product){
                                                        return product.categoryPageVisibility;
                                                });
                                                if (_this.hasCategoryPathFilter) { 
                                                    ItxFiltersManagerSvc.prototype.filterProductsBySubfamily();
                                                }
                                                deferred.resolve(_this.filteredProducts);                                            
                                                
                                                //_this.setCategoryCatentries(products.productsOrdered);
                                                
                                            });
                                    });
                            } 
                            else {
                                joyr.catalog.utils.setCategoryOrder(_this.category.id, [{}, {}])
                                    .done(function () {

                                        if(_this.filters.sizes){
                                            if(_this.filters.sizes.length > 0){
                                                products.productsFiltered = _this.ItxSizeGuideSvc.productHasSizes( _this.filters.sizes, products.productsFiltered );
                                            }
                                        }

                                        _this.filteredProducts = _.filter(products.productsFiltered, function(product){
                                            return product.categoryPageVisibility;
                                        });   
                                        // Filtrar aca por subfamilia.
                                        if (_this.hasCategoryPathFilter) { 
                                            ItxFiltersManagerSvc.prototype.filterProductsBySubfamily();
                                        }
                                        deferred.resolve(_this.filteredProducts);
                
                                        //_this.setCategoryCatentries(products.productsFiltered);
                                        
                                    });
                            }
                        });
                });

            return deferred.promise;
        };


        /**
         * Get current product selection after filtering
         * @returns {Array|null|*}
         */
        ItxFiltersManagerSvc.prototype.getFilteredProducts = function () {
            return _this.filteredProducts;
        };

    

        /**
         * Get current product count
         * @returns {Number}
         */
        ItxFiltersManagerSvc.prototype.getProductCount = function () {
            var _this = this;
            return _this.filteredProducts.length;
        };

        /**
         * Get all the products without any filter
         * @returns {Array|null|*}
         */
        ItxFiltersManagerSvc.prototype.getProducts = function () {
            var _this = this;
            return _this.categoryObject.visibleProducts;
        };

        /**
         * Get stored filters
         * @returns {{}|*}
         */
        ItxFiltersManagerSvc.prototype.getFilters = function () {
            var _this = this;
            return _this.filters;
        };

        ItxFiltersManagerSvc.prototype.removeFilter = function (filter) {
            var _this = this;
            _this.imCategoryFilter.deleteAttrFilter(filter);
            _.forEach(_this.filters[filter.typeFilter], function(item, index) {
              if(item) {
                if(filter.typeFilter === 'sizes') {
                  if(item === filter.value) {
                    _this.filters[filter.typeFilter].splice(index, 1);
                  }
                } else {
                  if(item.value === filter.value) {
                    _this.filters[filter.typeFilter].splice(index, 1);
                  }
                }
              }
            });
            return _this.applyFilters(
                _this.filters.types,
                _this.filters.qualities,
                _this.filters.characteristics,
                _this.filters.colors,
                _this.filters.sizes,
                _this.filters.prices
            );
        };

        ItxFiltersManagerSvc.prototype.getSelectedFilters = function (key) {
          var _this = this, labels = [];

          if (key === 'sizes') {
            //Sizes
          var sizes = [];
            _.each(_this.filters.sizes, function (size) {
              var obj = { value: size, type: 'sizes'}
              sizes.push(obj);
            });
            return sizes;
          } else if (['types', 'qualities', 'characteristics', 'colors'].indexOf(key) !== -1) {
            //Attrs & Colors
            var selected = [], obj = null;

            obj = _this.filters[key];

            selected = _.filter(obj, function (filter) {
              return filter.selected;
            });
            return selected;
          }
        }
    }  

    /**
   * Save catentryIds
   * @param products
   * @returns {*}
   */
  /*
    ItxFiltersManagerSvc.prototype.setCategoryCatentries = function (products) {
        var _this = this,
        index = 0;
        var productIds = _.map(products, function (product) {
            if(!(!product.bundleColors[0] && product.type === joyr.constants.product.BUNDLE_BEAN)) {
                var colors = product.type === joyr.constants.product.BUNDLE_BEAN ? product.bundleColors : product.activeDetail.colors;
                index = _.findIndex(colors, function(color) { return color.visibility !== 'hidden'; });
                if(index === -1) { return; }

                return {
                    id: product.id,
                    colorId: product.type === joyr.constants.product.PRODUCT_BEAN ? product.activeDetail.colors[index].id : product.bundleColors[0].id,
                    type: product.type,
                    name: product.name,
					parent: product.parent ? product.parent.id : null
                };
            }
        });

        _.remove(productIds, _.isUndefined);
        //Remove duplicates. Avoid errors when swiping between slides in product detail
        var productsIdsWithoutDuplicates = _.uniqWith(productIds, _.isEqual);

        if (productIds && productIds.length > 0) {
            sessionStorage.setItem(_this.ItxConstants.DuttiCategoryFilterKey,
                JSON.stringify({categoryId: _this.category.id, products: productsIdsWithoutDuplicates}));
                _this.ItxProductSwiperSvc.setCatentries(productsIdsWithoutDuplicates);
        }
        return productsIdsWithoutDuplicates;
    };
    */
   
})();
